import {
  getUserProfilesRequest,
  getUserProfilesResponse,
  type GetUserProfilesResponse,
} from '@core-api/user-profiles/user-profiles';
import useSWR, { type SWRConfiguration } from 'swr';
import userCache from '@mentimeter/user';
import { getUserProfilesSWRCacheKey } from './cache/getUserProfilesSWRCacheKey';
import { makeClientRequest } from './utils/makeClientRequest';

export function useUserProfiles(
  options: SWRConfiguration<GetUserProfilesResponse> = {},
) {
  const userAuth = userCache.getToken();
  const cacheKey = userAuth ? getUserProfilesSWRCacheKey('userProfiles') : null;

  return useSWR<GetUserProfilesResponse>(cacheKey, getUserProfiles, options);
}

async function getUserProfiles(): Promise<GetUserProfilesResponse> {
  const response = await fetch(makeClientRequest(getUserProfilesRequest, {}));
  return getUserProfilesResponse(response);
}
